import {
  deletesvg,
  edit,
  outlineuser,
  switchOff,
  switchOn,
} from '@assets/icons'
import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Svg from '@components/svg'
import Table from '@components/table'
import Title from '@components/title'
import { useModal } from '@context/ModalContext'
import React, { Fragment, useEffect, useState } from 'react'
import AddSubAdmin from '../add-subadmin-modal'
import DashboardCard from '@commons/cards/dashboard'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { Admin } from '@apis/index'
import axios from 'axios'
import dayjs from 'dayjs'

const Role = () => {
  const [page, setPage] = useState(1)
  const { showModal } = useModal()
  const {
    items: subadmins,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.subadmin)

  const fetchSubadmin = async () => {
    try {
      await Admin.subadmin({ state: 'subadmin', params: { page, limit: 30 } })
    } catch (error) {}
  }
  const columns = [
    { title: 'SN', key: 'sn', render: (_, i) => <p>{i}</p> },
    { title: 'Full Name', key: 'fullName' },
    { title: 'Email', key: 'email' },
    {
      title: 'Permission',
      key: 'permission',
      render: (item) => (
        <ol style={{ display: 'flex', flexDirection: 'column', rowGap: '6px' }}>
          {item?.permission?.map((p) => (
            <li>{p}</li>
          ))}
        </ol>
      ),
    },
    { title: 'Created On', key: 'createdOn' },
  ]
  const data = subadmins.map((sa) => ({
    id: sa.id,
    fullName: sa.name,
    email: sa.email,
    permission: sa?.infos?.permissions,
    createdOn: dayjs(sa.createdAt).format('YYYY-MM-DD HH:mm'),
  }))

  useEffect(() => {
    fetchSubadmin()
  }, [])
  return (
    <Fragment>
      <Column>
        <Title
          textone="Admin"
          texttwo="List"
          hasButton
          btnText="Add Sub Admin"
          onButtonClick={() => showModal(<AddSubAdmin />)}
        />
        {/* <DashboardCard /> */}

        <Table
          loading={loading}
          text="Admin List"
          icon={outlineuser}
          data={data}
          columns={columns}
          searchKeys={['fullName']}
          totalItems={totalItems}
          totalPages={totalPages}
          pageControlled={page}
          onPageChange={setPage}
          actions={[
            // { icon: edit, key: 'edit', onClick: (item) => {} },
            {
              icon: deletesvg,
              key: 'remove',
              onClick: async (item) => {
                await Admin.remove({ state: 'subadmin', id: item.id }).then(
                  () => {
                    window.location.reload()
                  },
                )
              },
            },
          ]}
        />
      </Column>
    </Fragment>
  )
}

export default Role
